module.exports = __webpack_public_path__ + "static/dyb-poster-set.bd93adf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dyb-poster-set.jpg
// module id = 481
// module chunks = 35783957827783